import { SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";

export interface CompanyIndustriesForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly sysName: string;
  readonly description: string;
}

export const companyIndustriesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "System Name",
    key: "sysName",
    width: 192,
    sort: true,
  },
  {
    title: "Description",
    key: "description",
    width: 320,
    sort: true,
  },
  {
    title: "Companies",
    key: "companiesCount",
    width: 320,
    sort: true,
    type: "badge",
  },
];

const companyIndustriesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "sysName" },
  { formField: "description" },
];

export const mapCompanyIndustriesViewQuery = (
  values: CompanyIndustriesForm,
): SearchQuery => buildSearchQuery(values, companyIndustriesQueryMappings);

export const industriesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "sysName", label: "System Name" },
        { type: "textbox", name: "description", label: "Description" },
      ],
    },
  ],
};
